export default function NumeroActividad({ imagen, texto, textoEditado }) {
  return (
    <div className="w-full grid justify-items-center my-6 bg-white rounded-xl shadow-sm  py-10 relative overflow-hidden">
      <div className="w-24 h-24 rounded-full flex justify-center items-center border-[#1d4ed8] border-[.5rem] mb-4 bg-white relative z-10">
        <p className="font-sans text-3xl text-nimbus font-bold">{texto}</p>
      </div>
      <div className="break-words max-w-[30rem] mx-auto relative z-10">
        <p
          dangerouslySetInnerHTML={{
            __html: textoEditado ?? '<span style="color:#1a3d82;font-size:19px;"><strong>Actividad</strong></span>',
          }}
        />
      </div>
    </div>
  )
}
